import { useNavigate } from 'react-router-dom'
import { Table, Input } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'
import TextInput from '../TextInput'
import YesNoSelect from '../YesNoSelect'

export default function LossSettlementFundingRequestForm({ location }) {
  console.log('LossSettlementFundingRequestForm rendered: ', location)

  let init = {
    firstName: '',
    lastName: '',
    plaintiffStatus: [],
    currentDiagnosis: [],
    plaintiffCounsel: [],
    defenseCounsel: [],
    groupId: '',
    settlementDateFrom: '',
    settlementDateTo: '',
    nextPaymentDueDateFrom: '',
    nextPaymentDueDateTo: '',
    dateMovedToPendingFrom: '',
    dateMovedToPendingTo: '',
    fundingDateFrom: '',
    fundingDateTo: '',
    amountOperator: '',
    settlementAmount: '',
    checkNumber: '',
    normalized: '',
    clientCode: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('LossSettlementFundingRequestForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('LossSettlementFundingRequestForm.submitSearch', inputs)

    for (let i = 0; i < inputs.plaintiffStatus.length; i++) {
      if (inputs.plaintiffStatus[i] === 'All') {
        inputs.plaintiffStatus.splice(i, 1)
      }
    }
    for (let i = 0; i < inputs.currentDiagnosis.length; i++) {
      if (inputs.currentDiagnosis[i] === 'All') {
        inputs.currentDiagnosis.splice(i, 1)
      }
    }
    for (let i = 0; i < inputs.plaintiffCounsel.length; i++) {
      if (inputs.plaintiffCounsel[i] === 'All') {
        inputs.plaintiffCounsel.splice(i, 1)
      }
    }
    for (let i = 0; i < inputs.defenseCounsel.length; i++) {
      if (inputs.defenseCounsel[i] === 'All') {
        inputs.defenseCounsel.splice(i, 1)
      }
    }
    submitFormValues('LossSettlementFundingRequestForm', navigate, inputs, 'internal_loss_settlement.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText='Loss Settlement List Report' />
            <tbody>
              <tr>
                <td><b>Plaintiff Name</b></td>
                <td>
                  <div style={{ display: 'inline-block' }}>
                    <Input className="custom-input" type='text' name='firstName' onChange={handleInputChange} defaultValue={inputs.firstName} />
                    <span><br /></span><div style={{ textAlign: 'center' }}><b>(First Name)</b></div>
                  </div>
                  <div style={{ display: 'inline-block' }}>
                    <Input className="custom-input" type='text' name='lastName' onChange={handleInputChange} defaultValue={inputs.lastName} />
                    <span><br /></span><div style={{ textAlign: 'center' }}><b>(Last Name)</b></div>
                  </div>
                </td>
              </tr>
              <CustomSelectListInput label="Plaintiff Status" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} allOption={true} defaultValue={inputs.plaintiffStatus} />
              <CustomSelectListInput label="Diagnosis" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="injury" name='currentDiagnosis' multiple={true} allOption={true} defaultValue={inputs.currentDiagnosis} />
              <CustomSelectListInput label="Plaintiff Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' multiple={true} allOption={true} defaultValue={inputs.plaintiffCounsel} />
              <CustomSelectListInput label="Defense Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="outside_firm" name='defenseCounsel' multiple={true} allOption={true} defaultValue={inputs.defenseCounsel} />
              <TextInput label='Group ID' name='groupId' handleInputChange={handleInputChange} defaultValue={inputs.groupId} />
              <DateRangeInput label='Settlement Date' name='settlementDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.settlementDateFrom} defaultValueTo={inputs.settlementDateTo} />
              <DateRangeInput label='Payment Due Date' name='nextPaymentDueDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.nextPaymentDueDateFrom} defaultValueTo={inputs.nextPaymentDueDateTo} />
              <DateRangeInput label='Date Moved To Pending' name='dateMovedToPending' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateMovedToPendingFrom} defaultValueTo={inputs.dateMovedToPendingTo} />
              <DateRangeInput label='Funding Date' name='fundingDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.fundingDateFrom} defaultValueTo={inputs.fundingDateTo} />
              <tr>
                <td><b>Settlement Amount</b></td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <Input
                    type="select"
                    name="amountOperator"
                    onChange={handleInputChange}
                    style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }}
                    defaultValue={inputs.amountOperator}
                  >
                    <option value={''}>Select Condition</option>
                    <option value={'<'}>Less Than &emsp;{'(<)'}</option>
                    <option value={'='}>Equal To &emsp;{'(=)'}</option>
                    <option value={'>'}>Greater Than &emsp;{'(>)'}</option>
                  </Input> &emsp;
                  <b>$</b><Input className="custom-input" type='number' onKeyDown={(e) => e.key === 'e' && e.preventDefault()} name='settlementAmount' onChange={handleInputChange} defaultValue={inputs.settlementAmount} />
                </td>
              </tr>
              <tr>
                <td><b>Check Number</b></td>
                <td>
                  <Input className="custom-input" type='text' name='checkNumber' onChange={handleInputChange} defaultValue={inputs.checkNumber} />
                  <span><br /></span><b>(Type "NULL" if specifically searching for records where there is no check number)</b>
                </td>
              </tr>
              <tr>
                <td><b>Normalized</b></td>
                <td><YesNoSelect name='normalized' handleChange={handleInputChange} defaultValue={inputs.normalized} /></td>
              </tr>
              <tr>
                <td><b>Client Code</b></td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <Input type="select" name="clientCode" onChange={handleInputChange} style={{ width: 'auto', display: 'inline-block', marginRight: '5px' }} defaultValue={inputs.clientCode}>
                    <option value={''}></option>
                    <option value={'2350'}>FW</option>
                    <option value={'2351'}>FWEC</option>
                  </Input>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}
